import { ROUTE_LOADING_SCREEN } from '@/constants/routes';
import { getRoute } from './get-route';

export function getRouteLoadingScreen(url: string, firstAssessment = false) {
  const path = encodeURIComponent(url);
  return getRoute(ROUTE_LOADING_SCREEN, { firstAssessment: `${firstAssessment}`, url: path });
}
